export const columnsObj = {
  name: {
    title: "Campaign",
    width: 240,
    dataIndex: "name",
    key: "name",
    fixed: "left",
    sorter: true,
  },
  daysIntoFlight: {
    title: "Days Into Flight",
    dataIndex: "daysIntoFlight",
    key: "daysIntoFlight",
    width: 120,
  },
  daysLeft: {
    title: "Days Left",
    dataIndex: "daysLeft",
    key: "daysLeft",
    width: 120,
    sorter: true,
  },
  expectedImpressions: {
    title: "Expected Imps",
    dataIndex: "expectedImpressions",
    key: "expectedImpressions",
    width: 120,
  },
  actualImpressions: {
    title: "Actual Imps",
    dataIndex: "actualImpressions",
    key: "actualImpressions",
    width: 120,
  },
  impressionsLeft: {
    title: "Imps Left",
    dataIndex: "impressionsLeft",
    key: "impressionsLeft",
    width: 120,
  },
  impressionsYesterday: {
    title: "Imps Yesterday",
    dataIndex: "impressionsYesterday",
    key: "impressionsYesterday",
    width: 120,
  },
  dailyAvgImpressionsLeft: {
    title: "Daily Avg Left",
    dataIndex: "dailyAvgImpressionsLeft",
    key: "dailyAvgImpressionsLeft",
    width: 120,
  },
  pace: {
    title: "Pace",
    dataIndex: "pace",
    key: "pace",
    width: 100,
    sorter: true,
  },
};

export const permanentKeys = [columnsObj.pace.key, columnsObj.name.key];

export const defaultColumnKeys = Object.keys(columnsObj);
